export default "__VITE_ASSET__8fb87ba1__"